import { Component } from 'react';

import { Box, Button, Container } from '@mui/material';
import { saveAs } from 'file-saver';
import { inject, observer } from 'mobx-react';
import { flowRight as compose } from 'lodash';
import { withRouter } from 'providers';

import EventList from '../EventList';
import TransactionDetails from '../TransactionDetails';

class DspTransactionInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount() {
    const { paymentStore, dsp } = this.props;
    paymentStore.getDspPaymentDetails(this.props.match.params.paymentId);
  }
  downloadPaymentCSV = () => {
    if (this.state.downloadingCSV) return;
    const { paymentStore, match } = this.props;
    const { params } = match || {};
    const { paymentId } = params || {};
    this.setState({ downloadingCSV: true });
    paymentStore.getDspPaymentCSV(paymentId).then((csv) => {
      this.setState({ downloadingCSV: false });
      if (!csv) return;
      const filename = `${paymentId}.csv`;
      const blob = new Blob([csv], { type: 'text/plain;charset=utf-8' });
      saveAs(blob, filename);
    });
  };

  render() {
    const { paymentStore } = this.props;
    const { repayStatus, paymentDetails } = paymentStore;

    return (
      <Container maxWidth={false}>
        <Box sx={{ display: 'flex' }}>
          <Box sx={{ flex: 1, marginRight: '10px' }}>
            <TransactionDetails dsp paymentDetails={paymentDetails} />
            <Button variant="contained" color="primary" onClick={this.downloadPaymentCSV} size='small' disableElevation>
              Download CSV
            </Button>
          </Box>
          <Box sx={{ flex: 3, marginLeft: '10px' }}>
            <EventList pagination paymentDetails={paymentDetails} repayStatus={repayStatus} />
          </Box>
        </Box>
      </Container>
    );
  }
}

export default compose(withRouter, inject('paymentStore'), observer)(DspTransactionInfo);
